<template>
  <div class="article">
    <div class="title">洪子晴爵士出席中国驻迪拜总领馆举办“杭州数字企业走进总领馆”活动</div>
    <div class="info">作者：晴天集团    发布于：2025-06-11 18:18</div>
    <p>2025年5月21日，中国驻迪拜总领馆举办“杭州数字企业走进总领馆”活动，杭州链泊云科技、宇树科技、云深处科技等20余家杭州企业携尖端产品亮相。在认真听取了各企业的介绍后，欧渤芊总领事深入解读中阿经贸合作与迪拜发展机遇，并为企业在迪投资经营提出建议。欧渤芊总领事强调，当前，全球数字经济蓬勃发展，跨境投融资合作日益深化，杭州作为中国数字经济的标杆城市，与迪拜这一中东金融和创新中心合作契合点多，前景广阔。希望杭州数字企业把握机遇，充分发挥创新优势，与迪拜在智慧城市、电子商务、人工智能等领域深化合作，为中阿高质量共建“一带一路”注入数字动能。活动现场，机器人、机器狗等纷纷展示“绝活”，用最硬核的方式展示中国创新魅力，呈现了一场数字中国软实力的沉浸式剧场。纳斯达克迪拜是中东、非洲与南亚区域的国际型证券交易所。纳斯达克迪拜交易所总部位于迪拜国际金融中心（DIFC）。</p>
    <p>Lady Athena Hung Chi Ching attended the "Hangzhou Digital Enterprises Entering the Consulate General" event held by the Chinese Consulate General in Dubai</p>
    <p>On May 21, 2025, the Chinese Consulate General in Dubai held the "Hangzhou Digital Enterprises Entering the Consulate General" event, and more than 20 Hangzhou companies such as Hangzhou UEOPLE TECHNOLOGY HOLDING LIMITED, Yushu Technology, and Yunshenchu Technology appeared with cutting-edge products. After carefully listening to the introductions of various companies, Consul General Ou Boqian deeply interpreted the China-Arab economic and trade cooperation and Dubai's development opportunities, and made suggestions for companies to invest and operate in Dubai. Consul General Ou Boqian emphasized that at present, the global digital economy is booming, and cross-border investment and financing cooperation is deepening. Hangzhou, as a benchmark city for China's digital economy, has many points of convergence with Dubai, the financial and innovation center in the Middle East, and has broad prospects. It is hoped that Hangzhou digital companies will seize opportunities, give full play to their innovative advantages, and deepen cooperation with Dubai in the fields of smart cities, e-commerce, artificial intelligence, etc., to inject digital momentum into the high-quality joint construction of the "Belt and Road" between China and the Arab countries. At the event, robots, robot dogs, etc. showed their "unique skills" one after another, showing the charm of China's innovation in the most hardcore way, presenting an immersive theater of digital China's soft power. Nasdaq Dubai is an international stock exchange in the Middle East, Africa and South Asia. Nasdaq Dubai is headquartered in Dubai International Financial Centre (DIFC).</p>
    <img src="@/assets/img/article/0611/1.webp" alt="">
    <p class="img-alt">浙江省驻阿联酋商务代表处商务代表毛文先生进在迪拜纳斯达克发言中</p>
    <p class="img-alt-content">Mr. Mao Wenjin, Commercial Representative of the Zhejiang Provincial Commercial Representative Office in the United Arab Emirates, delivered a speech at Nasdaq Dubai.</p>
    <img src="@/assets/img/article/0611/2.webp" alt="">
    <p class="img-alt">中国驻迪拜总领馆参赞王晓佳先生在迪拜纳斯达克发言中</p>
    <p class="img-alt-content">Mr. Wang Xiaojia, Counselor of the Chinese Consulate - General in Dubai, delivered a speech at Nasdaq Dubai.</p>
    <img src="@/assets/img/article/0611/3.webp" alt="">
    <p class="img-alt">迪拜纳斯达克嘉宾发言中</p>
    <p class="img-alt-content">During the guest speech at Nasdaq Dubai</p>
    <img src="@/assets/img/article/0611/4.webp" alt="">
    <p class="img-alt">迪拜纳斯达克嘉宾发言中</p>
    <p class="img-alt-content">During the guest speech at Nasdaq Dubai</p>
    <img src="@/assets/img/article/0611/5.webp" alt="">
    <p class="img-alt">洪子晴爵士与阿联酋嘉宾合影</p>
    <p class="img-alt-content">Lady Athena Hung Chi Ching poses for a group photo with Emirati guests</p>
    <img src="@/assets/img/article/0611/6.webp" alt="">
    <p class="img-alt">洪子晴爵士与阿联酋嘉宾合影</p>
    <p class="img-alt-content">Lady Athena Hung Chi Ching poses for a group photo with Emirati guests</p>
    <img src="@/assets/img/article/0611/7.webp" alt="">
    <p class="img-alt">洪子晴爵士与驻迪拜总领事欧渤芊女士合影</p>
    <p class="img-alt-content">Lady Athena Hung Chi Ching took a group photo with Ms. Ou Boqian, Consul General in Dubai.</p>
    <img src="@/assets/img/article/0611/8.webp" alt="">
    <p class="img-alt">洪子晴爵士与迪拜企业家们合影</p>
    <p class="img-alt-content">Lady Athena Hung Chi Ching took a group photo with Dubai entrepreneurs.</p>
  </div>
</template>

<script>
export default {
  name: '1',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.article{
  width: 70%;
  margin: 20px auto;
  font-family: $font-family;
  .title{
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
  }

  .info{
    height: 28px;
    line-height: 28px;
    border-bottom: 1px #e8e8e8 solid;
    margin: 0;
    text-align: center;
    font-size: 0.8rem;
  }

  p{
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    margin: 20px 0;
  }

  img{
    width: 60%;
    margin-left: 20%;
  }

  .img-alt{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 10px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }

  .img-alt-content{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 5px;
    padding-bottom: 15px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .article{
    width: 90%;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 80%;
      margin-left: 10%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      color: #2f2e2e;
      padding-top: 5px;
      font-size: 0.8rem;
    }
    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.8rem;
    }
  }
}

@media (max-width: 480px) {
  .article{
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 100%;
      margin: 0;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      font-size: 0.7rem;
      margin: 6px 0;
      color: #666;
    }
  }
}
</style>
